<template>
    <!-- Layout inner -->
    <div class="layout-inner dashbaord degree_progress">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">
          <!---<stream-degree-secondary-navbar :active="'credit'"></stream-degree-secondary-navbar>-->

          <div class="hd_bar">
            <div class="hd_ic">
              <span class="ic-summary"></span>
            </div>
            <div class="hd_txt">
              <span class="title_txt" id="userName">{{userName}}'s Summary</span>

              <b-popover ref="userNamePopupContainer" target="userName" triggers="click" placement="top" class="title_popup" container="userNameContainer">
                <div class="title_container">
                  {{userName}}'s Summary
                </div>
                <div class="ic_container">
                  <span class="ic ic-close" v-on:click="hideUserNamePopup"></span>
                </div>
              </b-popover>
              <div id="userNameContainer" class="title_container_popup"></div>
            </div>
            <div class="more-link">
              <b-link class="info_popup_link" :id="'disclaimerLink'" aria-label="disclaimer">
                <span class="exclamation-circle"><span class="fas fa-exclamation-circle"></span></span>
              </b-link>

              <div id="disclaimerPopup" class="info_popup">
                  <b-popover
                    :target="'disclaimerLink'"
                  triggers="hover focus"
                  container="disclaimerPopup">
                    <div class="info_popup_content">
                      Please contact your advisor for the exact program requirements and additional clarifications
                    </div>
                  </b-popover>
              </div>
            </div>
          </div>

          <!-- Page content -->
          <div class="container-fluid flex-grow-1 pg_content_container">

            <b-tabs v-model="tabIndex">

              <b-tab no-body title="Program Progress" :title-link-class="linkClass(0)" title-item-class="w-50 text-center">

                <div class="row pg_content_col legends">
                  <div class="col-4 status_row"><span class="lg_blc gc_transferred"></span> Transferred</div>
                  <div class="col-4 status_row"><span class="lg_blc gc_completed"></span> Completed</div>
                  <div class="col-4 status_row"><span class="lg_blc gc_in_progress"></span> In Progress</div>
                  <div class="col-4 status_row"><span class="lg_blc gc_in_scheduled"></span> Scheduled </div>
                  <div class="col-8 status_row"><span class="lg_blc gc_credits_needed"></span> {{creditLabel}}s Needed</div>
                </div>
                <div class="w-100 mt-5 pt-5" v-if="showLoader">
                  <spinner size="large"></spinner>
                </div>
                <div class="row">
                  <template v-for="(pg, index) in planningStream.programGuides" v-if="pg.progress.courseValues.length > 0">

                    <div class="col-6 chart_container" :aria-label="pg.title">
                      <div class="pie_chart" :id="'piechart_' + index"></div>
                      <div class="title_new">
                        <v-clamp v-if="isShowPieChartLabel" class="title_txt" autoresize :max-lines="2" :id="'graph_' + index">{{ pg.title }}</v-clamp>

                        <b-popover :ref="'graphTitlePopupContainer_' + index" :target="'graph_' + index" triggers="click" placement="top" class="title_popup" :container="'graphTitleContainer_' + index">
                          <div class="title_container">
                            {{pg.title}}
                          </div>
                          <div class="ic_container">
                            <span class="ic ic-close" v-on:click="hideGraphTitlePopup(index)"></span>
                          </div>
                        </b-popover>
                        <div :id="'graphTitleContainer_' + index" class="title_container_popup"></div>
                      </div>
                    </div>

                  </template>
                </div>
              </b-tab>

              <b-tab no-body title="Course Progress" :title-link-class="linkClass(1)" title-item-class="w-50 text-center" class="course_progress_tab_content">

                <div class="accordion">
                  <div class="head" role="heading" v-b-toggle.collapse-1 variant="primary">
                    <div class="tag-type-status" style="background: #56b5e8;">
                        <div class="ic_container">
                          <span class="ic ic-add_circle"></span>
                          <span class="ic ic-remove_circle"></span>
                        </div>
                        <div>Transferred Courses</div>
                    </div>
                  </div>
                  <b-collapse id="collapse-1">
                    <template v-for="(t, index) in transferredCourses">
                      <div class="tag" @click="closeAllPopovers()" :id="'transferredCourseTitle_' + index" style="cursor: pointer;">
                          <span class="competency-tag">{{t.title}}</span>
                      </div>

                      <b-popover :ref="'courseTitlePopupContainer_tc' + index" :target="'transferredCourseTitle_' + index" triggers="click" placement="top" class="title_popup" :container="'transferredCourseTitleContainer_' + index">
                        <div class="title_container">
                          {{t.title}}
                        </div>
                        <div class="ic_container">
                          <span class="ic ic-close" v-on:click="hideCourseTitlePopup('tc', index)"></span>
                        </div>
                      </b-popover>
                      <div :id="'transferredCourseTitleContainer_' + index" class="title_container_popup"></div>

                    </template>

                </b-collapse>
                </div>

                <div class="accordion">
                  <div class="head" role="heading" v-b-toggle.collapse-2 variant="primary">
                    <div class="tag-type-status" style="background: #508102;">
                        <div class="ic_container">
                          <span class="ic ic-add_circle"></span>
                          <span class="ic ic-remove_circle"></span>
                        </div>
                        <div>Completed Courses</div>
                    </div>
                  </div>
                  <b-collapse id="collapse-2">
                    <template v-for="(c, index) in completedCourses">
                      <div class="tag" @click="closeAllPopovers()" :id="'completedCourseTitle_' + index" style="cursor: pointer;">
                          <span class="competency-tag">{{c.title}}</span>
                      </div>

                      <b-popover :ref="'courseTitlePopupContainer_cc' + index" :target="'completedCourseTitle_' + index" triggers="click" placement="top" class="title_popup" :container="'completedCourseTitleContainer_' + index">
                        <div class="title_container">
                          {{c.title}}
                        </div>
                        <div class="ic_container">
                          <span class="ic ic-close" v-on:click="hideCourseTitlePopup('cc', index)"></span>
                        </div>
                      </b-popover>
                      <div :id="'completedCourseTitleContainer_' + index" class="title_container_popup"></div>

                    </template>
                  </b-collapse>
                </div>

                <div class="accordion">
                  <div class="head" role="heading" v-b-toggle.collapse-3 variant="primary">
                    <div class="tag-type-status" style="background: #9fc958;">
                      <div class="ic_container">
                        <span class="ic ic-add_circle"></span>
                        <span class="ic ic-remove_circle"></span>
                      </div>
                      <div>In Progress Courses</div>
                    </div>
                  </div>
                  <b-collapse id="collapse-3">
                    <template v-for="(i, index) in inprogressCourses">
                      <div class="tag" @click="closeAllPopovers()" :id="'inprogressCourseTitle_' + index" style="cursor: pointer;">
                          <span class="competency-tag">{{i.title}}</span>
                      </div>

                      <b-popover :ref="'courseTitlePopupContainer_ic' + index" :target="'inprogressCourseTitle_' + index" triggers="click" placement="top" class="title_popup" :container="'inprogressCourseTitleContainer_' + index">
                        <div class="title_container">
                          {{i.title}}
                        </div>
                        <div class="ic_container">
                          <span class="ic ic-close" v-on:click="hideCourseTitlePopup('ic', index)"></span>
                        </div>
                      </b-popover>
                      <div :id="'inprogressCourseTitleContainer_' + index" class="title_container_popup"></div>

                    </template>
                    <template v-for="(g, index) in gradePendingCourses">
                      <div class="tag" @click="closeAllPopovers()" :id="'gradePendingCourseTitle_' + index" style="cursor: pointer;">
                          <span class="competency-tag">{{g.title}}</span>
                      </div>

                      <b-popover :ref="'courseTitlePopupContainer_gc' + index" :target="'gradePendingCourseTitle_' + index" triggers="click" placement="top" class="title_popup" :container="'gradePendingCourseTitleContainer_' + index">
                        <div class="title_container">
                          {{g.title}}
                        </div>
                        <div class="ic_container">
                          <span class="ic ic-close" v-on:click="hideCourseTitlePopup('gc', index)"></span>
                        </div>
                      </b-popover>
                      <div :id="'gradePendingCourseTitleContainer_' + index" class="title_container_popup"></div>

                    </template>
                  </b-collapse>
                </div>

                <div class="accordion">
                  <div class="head" role="heading" v-b-toggle.collapse-4 variant="primary">
                    <div class="tag-type-status" style="background: #f5b518;">
                      <div class="ic_container">
                        <span class="ic ic-add_circle"></span>
                        <span class="ic ic-remove_circle"></span>
                      </div>
                      <div>Scheduled Courses</div>
                    </div>
                  </div>
                  <b-collapse id="collapse-4">
                    <template v-for="(s, index) in scheduledCourses">
                      <div class="tag" @click="closeAllPopovers()" :id="'scheduledCourseTitle_' + index" style="cursor: pointer;">
                          <span class="competency-tag">{{s.title}}</span>
                      </div>

                      <b-popover :ref="'courseTitlePopupContainer_sc' + index" :target="'scheduledCourseTitle_' + index" triggers="click" placement="top" class="title_popup" :container="'scheduledCourseTitleContainer_' + index">
                        <div class="title_container">
                          {{s.title}}
                        </div>
                        <div class="ic_container">
                          <span class="ic ic-close" v-on:click="hideCourseTitlePopup('sc', index)"></span>
                        </div>
                      </b-popover>
                      <div :id="'scheduledCourseTitleContainer_' + index" class="title_container_popup"></div>

                    </template>
                  </b-collapse>
                </div>

              </b-tab>
            </b-tabs>
          </div>
          <!-- / Page content -->

          <!-- Footer Navbar -->
          <stream-footer-navbar :uuid="uuid" :isCareerEnabled="isSkillTaggingEnabled"></stream-footer-navbar>
          <!-- / Footer Navbar -->
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { PACKAGE } from '../../../package_constants'
import { mapActions, mapState } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import StreamDegreeSecondaryNavbar from '../../misc/components/./StreamDegreeSecondaryNavbar'
import StreamFooterNavbar from '../../misc/components/./StreamFooterNavbar'
import VClamp from 'vue-clamp'
import * as d3 from 'd3'

export default {
  name: 'streamDegree',
  props: ['uuid'],
  components: {
    Navbar,
    VClamp,
    StreamDegreeSecondaryNavbar,
    StreamFooterNavbar
  },
  data: () => {
    return {
      tabIndex: 0,
      showLoader: false,
      isShowPieChartLabel: false
    }
  },

  mounted () {
    this.loadStreamDegree()
  },

  methods: {
    ...mapActions([
      'loadPlanningStream',
      'loadUserObj',
      'loadInstitutionDetail',
      'loadInstitutionPackage'
    ]),
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['active']
      } else {
        return ['bg-primary', 'text-light']
      }
    },
    async loadStreamDegree () {
      this.showLoader = true
      await this.loadUserObj()
      await this.loadInstitutionDetail(this.userObj.institutionId).then(res => {
        this.loadInstitutionPackage({uuid: res.uuid, isAggregated: false})
      })
      await this.loadPlanningStream()
      if (this.planningStream.programGuides) {
        this.isShowPieChartLabel = false
        let showCreditProgress = this.isShowCreditProgressEnabled
        let showCourseProgress = this.isShowCourseProgressEnabled
        let showCourseProgressOnOverall = this.isShowCourseProgressOnOverallEnabled
        this.planningStream.programGuides.forEach((programGuide, i) => {
          if (programGuide.title === 'Overall' && (!(showCourseProgress || showCourseProgressOnOverall) || showCreditProgress)) {
            this.generatePieChart(programGuide.progress.values, 'piechart_' + i)
            programGuide.title = 'Overall ' + this.creditLabel + 's'
          } else if (showCourseProgress || showCourseProgressOnOverall) {
            this.generatePieChart(programGuide.progress.courseValues, 'piechart_' + i)
            programGuide.title = programGuide.title + ' Courses'
          } else {
            this.generatePieChart(programGuide.progress.values, 'piechart_' + i)
          }
          this.isShowPieChartLabel = ((this.planningStream.programGuides.length - 1) === i)
        })
      }
      this.showLoader = false
    },
    getLabel (label) {
      if (label.indexOf('credits') !== -1) {
        return label.replace('credit', this.creditLabel.toLowerCase())
      }
      return label
    },
    generatePieChart (data, elementId) {
      let colorScale = {
        'transferred': '#56b5e8',
        'completed': '#508102',
        'in progress': '#9fc958',
        'scheduled': '#f5b518',
        'credits needed': '#d07b08',
        'not in plan': '#969696',
        'in the plan': '#1eb1eb',
        'transferred courses': '#56b5e8',
        'completed courses': '#508102',
        'in progress courses': '#9fc958',
        'scheduled courses': '#f5b518',
        'courses needed': '#d07b08'
      }
      var pieChartContainerHeight = 140
      var pieChartInnerRadius = 30
      var width = pieChartContainerHeight
      var height = pieChartContainerHeight
      var radius = pieChartContainerHeight / 2

      var tooltip = d3.select('body')
                    .append('div')
                    .style('position', 'absolute')
                    .style('z-index', '10')
                    .style('visibility', 'hidden')
                    .style('color', '#111')
                    .attr('class', 'report-tooltip-xaxis')
                    .style('padding', '8px')
                    .style('border-radius', '6px')
                    .style('font', 'bold 15px Arial')
                    .text('tooltip')

      var canvas = d3.select('#' + elementId).append('svg')
                   .data([data]).attr('width', width).attr('height', height).append('g')
                   .attr('transform', 'translate(' + radius + ',' + radius + ')')

      var arc = d3.arc()
                .outerRadius(radius)
                .innerRadius(pieChartInnerRadius)

      var pie = d3.pie()
                .value(function (d) { return d.value }).sort(null)

      var arcs = canvas.selectAll('.arc')
                 .data(pie(data))
                 .enter().append('g')
                 .attr('class', 'arc')

      arcs.append('path')
          .attr('d', arc)
          .style('fill', (d, i) => { return colorScale[d.data.label] })
          .on('mouseover', (d) => {
            tooltip.text(this.getLabel(d.data.label) + ': ' + d.data.value + (''))
            tooltip.style('visibility', 'visible')
          })
          .on('mousemove', function () {
            return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
          })
          .on('mouseout', function () {
            return tooltip.style('visibility', 'hidden')
          })

      arcs.append('text')
          .attr('transform', (d) => { return 'translate(' + arc.centroid(d) + ')' })
          .style('font', 'bold 12px Arial')
          .style('fill', '#fff')
          .style('cursor', 'default')
          .attr('text-anchor', 'middle')
          .text((d) => { return d.data.value })
          .on('mouseover', (d) => {
            tooltip.text(this.getLabel(d.data.label) + ': ' + d.data.value + (''))
            tooltip.style('visibility', 'visible')
          })
          .on('mousemove', () => {
            return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
          })
          .on('mouseout', () => {
            return tooltip.style('visibility', 'hidden')
          })
    },
    hideUserNamePopup () {
      this.$refs.userNamePopupContainer.$emit('close')
    },
    hideGraphTitlePopup (index) {
      let ref = 'graphTitlePopupContainer_' + index
      this.$refs[ref][0].$emit('close')
    },
    hideCourseTitlePopup (courseType, index) {
      let ref = 'courseTitlePopupContainer_' + courseType + index
      this.$refs[ref][0].$emit('close')
    },
    closeAllPopovers () {
      this.$root.$emit('bv::hide::popover')
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'planningStream': state => state.dashboard.stream,
      'enabledFeatures': state => state.dashboard.enabledFeatures
    }),
    creditLabel () {
      let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
      if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
        return 'Credit'
      }
      return creditLabelFeature.label
    },
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    major () {
      if (this.userObj) {
        return this.userObj.major1Title
      } else {
        return ''
      }
    },
    majorGPA () {
      if (this.userObj) {
        return this.userObj.majorGpa
      } else {
        return '0.0'
      }
    },
    overallGPA () {
      if (this.userObj) {
        return this.userObj.overallGpa
      } else {
        return '0.0'
      }
    },
    overallCreditsCompleted () {
      if (this.planningStream.programGuides && this.planningStream.programGuides.length > 1 && this.planningStream.programGuides[0].progress) {
        return this.planningStream.programGuides[0].progress.completed + this.planningStream.programGuides[0].progress.transfered
      }
      return ''
    },
    overallTotalCredits () {
      if (this.planningStream.programGuides && this.planningStream.programGuides.length > 1 && this.planningStream.programGuides[0].progress) {
        return this.planningStream.programGuides[0].progress.total
      }
      return ''
    },
    isShowCreditProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCreditProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCourseProgressOnOverallEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgressOnOverall') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCourseProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isSkillTaggingEnabled () {
      let skillTaggingFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_FEATURE_ID]
      if (skillTaggingFeature) {
        return skillTaggingFeature.enabled
      }
      return false
    },
    progressView () {
      if (this.planningStream.progressViewStructure) {
        return JSON.parse(this.planningStream.progressViewStructure)
      } else {
        return {}
      }
    },
    transferredCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.transferred
      } else {
        return []
      }
    },
    completedCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.completed
      } else {
        return []
      }
    },
    inprogressCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.inprogress
      } else {
        return []
      }
    },
    gradePendingCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.gradePending
      } else {
        return []
      }
    },
    incompleteCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.incomplete
      } else {
        return []
      }
    },
    scheduledCourses () {
      var progressViewStructure = this.progressView
      if (progressViewStructure) {
        return progressViewStructure.scheduled
      } else {
        return []
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/stream/components/StreamDegree.vue